// extracted by mini-css-extract-plugin
export default {"link":"CxList_link__UJltI","text":"CxList_text__TNINV","longText":"CxList_longText__AWvc6"};